import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Functions } from '@hub/common/Functions';
import { eModules } from '@hub/generated/enums';
import { HyperlinkDto } from '@hub/generated/models';

@Component({
	selector: 'g-columnHyperlink',
	templateUrl: './columnHyperlink.component.html',
})
export class ColumnHyperlinkComponent implements OnInit {
	constructor(private router: Router) { }

	@Input() data: HyperlinkDto;

	@Input() moduleId: number;
	@Input() isEditing: boolean = false;

	ngOnInit() {
	}

	navigate() {
		if (this.data.ExternalUrlAddress == null) {
			// condition for generating url for router outlets
			if (Functions.getEnumName(eModules, this.data.ModuleId, false).toLowerCase() == 'deals') {
				this.router.navigateByUrl('pa/' + this.data.Slug + "/detail");
			}

			if (Functions.getEnumName(eModules, this.data.ModuleId, false).toLowerCase() == 'tv10bookings') {
				this.router.navigateByUrl(Functions.getEnumName(eModules, this.data.ModuleId, false).toLowerCase() + '/' + this.data.Slug);
			}
			// for User
			if ((Functions.getEnumName(eModules, this.data.ModuleId, false).toLowerCase() == 'users')) {
				// TODO: fix this for slugs
				this.router.navigateByUrl(Functions.getEnumName(eModules, this.data.ModuleId, false).toLowerCase() + '/detail/' + this.data.Slug + "/administration");
			}
			if (Functions.getEnumName(eModules, this.data.ModuleId, false).toLowerCase() == 'clients') {
				this.router.navigateByUrl(Functions.getEnumName(eModules, this.data.ModuleId, false).toLowerCase() + '/' + this.data.Slug + '/detail');
			}

			if (Functions.getEnumName(eModules, this.data.ModuleId, false).toLowerCase() == 'buyers') {
				this.router.navigateByUrl(Functions.getEnumName(eModules, this.data.ModuleId, false).toLowerCase() + '/' + this.data.Slug + '/detail');
			}

		if (Functions.getEnumName(eModules, this.data.ModuleId, false).toLowerCase() == 'packages') {
			this.router.navigateByUrl(Functions.getEnumName(eModules, this.data.ModuleId, false).toLowerCase() + '/' + this.data.Slug);
		}

			if (Functions.getEnumName(eModules, this.data.ModuleId, false).toLowerCase() == 'contacts') {
				this.router.navigateByUrl(Functions.getEnumName(eModules, this.data.ModuleId, false).toLowerCase() + '/' + this.data.Slug + '/detail');
			}
		}
		else {
			window.open(this.data.ExternalUrlAddress, "_blank");
		}
	}
}
